module.exports = __webpack_public_path__ + "media/landing_page/city-page-hero-desktop-fb99707f.webp";